/* global EventBus, app */
import axios from 'axios'

export default {
    fetchChannel ({ commit }, channelId) {
        return axios.get(`/api/channel/${channelId}`).then((response) => {
            const channel = response.data.data

            commit('SET_CHANNEL', channel)
            commit('SET_COLUMNS', channel.columns)
        })
    },

    fetchJobs ({ commit }, channelId) {
        return axios.get(`/api/channel/${channelId}/job`).then(response => {
            commit('SET_JOBS', response.data.data)
        })
    },

    fetchMembers ({ commit }, channelId) {
        return axios.get(`/api/channel/${channelId}/members`).then((response) => {
            commit('SET_MEMBERS', response.data.data)
        })
    },

    fetchArchive ({ commit, state }) {
        state.archive.fetch(`/api/channel/${state.channel.id}/job/archived`).then((response) => {
            commit('SET_ARCHIVE', response.data)
        })
    },

    fetchJobMembers ({ commit }, job) {
        return axios.get(`/api/job/${job.id}/members`).then((response) => {
            commit('SET_JOB_MEMBERS', { job, members: response.data })
        })
    },

    fetchLabels ({ commit }, channelId) {
        return axios.get(`/api/channel/${channelId}/labels`).then((response) => {
            commit('SET_LABELS', response.data.data)
        })
    },

    removeMember ({ state, commit }, user) {
        return axios.delete(`/api/channel/${state.channel.id}/members/${user.id}`).then(() => {
            commit('REMOVE_MEMBER', user.id)
        })
    },

    updateChannel ({ commit, state }, form) {
        return form.put(`/api/channel/${state.channel.id}`).then((response) => {
            commit('SET_CHANNEL', response.data)
        })
    },

    createColumn ({ commit, state }, form) {
        return form.post(`/api/channel/${state.channel.id}/column`).then((response) => {
            commit('ADD_COLUMN', response)
        })
    },

    renameColumn ({ commit, state }, data) {
        return data.form.put(`/api/channel/${state.channel.id}/column/${data.column.id}`).then((response) => {
            commit('SET_COLUMN', response)
        })
    },

    repositionColumn ({ commit, state }, { id, position }) {
        commit('REPOSITION_COLUMN', { id, position })

        return axios.put(`/api/channel/${state.channel.id}/column/${id}/position`, { position: position })
    },

    repositionAllColumns ({ commit, state }) {
        state.columns.forEach((column, index) => {
            return axios.put(`/api/channel/${state.channel.id}/column/${column.id}/position`, { position: 8192 * (index + 1) }).then((response) => {
                commit('REPOSITION_COLUMN', {
                    id: column.id,
                    position: response.data.position
                })
            })
        })
    },

    deleteColumn ({ commit, state }, column) {
        return axios.delete(`/api/channel/${state.channel.id}/column/${column.id}`).then(() => {
            commit('REMOVE_COLUMN', column.id)
        })
    },

    createJob ({ commit, state }, form) {
        return form.post(`/api/channel/${state.channel.id}/job`).then((response) => {
            commit('ADD_JOB', response)
            EventBus.$emit('newSnackbar', `Job '${response.title}' was created`)
        })
    },

    repositionJob ({ commit, state }, data) {
        commit('SET_JOB', data)

        return axios.put(`/api/job/${data.id}/position`, data).then((response) => {
            // TODO: This is wank, make gud
            return new Promise((resolve, reject) => {
                resolve(response)
            })
        })
    },

    repositionAllJobs ({ dispatch }, jobs) {
        jobs.forEach((job, index) => {
            dispatch('repositionJob', {
                id: job.id,
                column_id: job.column_id,
                position: app.config.INITIAL_JOB_POSITION * (index + 1)
            })
        })
    },

    archiveJob ({ commit }, job) {
        commit('REMOVE_JOB', job.id)

        return axios.post(`/api/job/${job.id}/archived`).then(() => {
            commit('ADD_ARCHIVED_JOB', job)
            EventBus.$emit('newSnackbar', `Job '${job.title}' was archived`)
        })
    },

    archiveJobs ({ commit, state }, column) {
        return axios.post(`/api/channel/${state.channel.id}/column/${column.id}/archive`).then(() => {
            commit('REMOVE_COLUMN_JOBS', column.id)
        })
    },

    reinstateJob ({ commit }, { jobId, columnId }) {
        commit('REMOVE_ARCHIVED_JOB', jobId)

        return axios.delete(`/api/job/${jobId}/archived`, {
            headers: { 'Content-Type': 'application/json' },
            data: { column_id: columnId }
        }).then((response) => {
            const job = response.data

            commit('ADD_JOB', job)
            EventBus.$emit('newSnackbar', `Job '${job.title}' was reinstated`)
        })
    },

    addMembers ({ state, commit }, form) {
        return form.post(`/api/channel/${state.channel.id}/members`).then((response) => {
            commit('SET_MEMBERS', response.data)
        })
    },

    inviteMembers ({ state, commit }, form) {
        return form.post(`/api/channel/${state.channel.id}/invites`).then((response) => {
            if (form.force === true) {
                commit('SET_MEMBERS', response.data)
            }
        })
    },

    saveIntegrations ({ commit, state }, form) {
        return form.put(`/api/channel/${state.channel.id}/integrations`).then((response) => {
            commit('SET_CHANNEL', response)
        })
    },

    fetchCurrentChannelMember ({ commit, state }) {
        return axios.get(`/api/channel/${state.channel.id}/current-member`).then((response) => {
            commit('SET_CURRENT_CHANNEL_MEMBER', response.data)
        })
    },

    saveCurrentChannelMember ({ commit, state }, form) {
        return form.put(`/api/channel/${state.channel.id}/current-member`).then((response) => {
            commit('SET_CURRENT_CHANNEL_MEMBER', response)
        })
    },

    addLabel ({ commit, state }, form) {
        return form.post(`/api/channel/${state.channel.id}/labels`).then((response) => {
            commit('ADD_LABEL', response.data)

            return response.data
        })
    },

    updateLabel ({ commit, state }, { labelId, form }) {
        return form.put(`/api/channel/${state.channel.id}/labels/${labelId}`).then((response) => {
            commit('SET_LABEL', response.data)
        })
    },

    removeLabel ({ commit, state }, labelId) {
        return axios.delete(`/api/channel/${state.channel.id}/labels/${labelId}`).then(() => {
            commit('REMOVE_LABEL', labelId)
        })
    },

    addJobLabel ({ commit, state }, { jobId, labelId }) {
        return axios.post(`/api/job/${jobId}/labels`, { label_id: labelId }).then((response) => {
            commit('ADD_JOB_LABEL', { job_id: jobId, label: response.data.data })
        })
    },

    removeJobLabel ({ commit, state }, { jobId, labelId }) {
        return axios.delete(`/api/job/${jobId}/labels/${labelId}`).then(() => {
            commit('REMOVE_JOB_LABEL', { job_id: jobId, label_id: labelId })
        })
    },

    toggleFilter ({ commit, state, getters }, { filter, value }) {
        let filters = state.filters

        if (filters[filter].includes(value)) {
            filters[filter] = filters[filter].filter(filterValue => filterValue !== value)
        } else {
            filters[filter].push(value)
        }

        commit('SET_FILTERS', filters)
    },

    clearFilters ({ commit }) {
        commit('CLEAR_FILTERS')
    },

    removeJob ({ commit }, jobId) {
        axios.delete(`/api/job/${jobId}`).then(() => {
            commit('REMOVE_ARCHIVED_JOB', jobId)
        })
    }
}
